<template>
  <div class="row">
    <div class="col-md-10 col-md-offset-1">
      <h3>Condizioni d'uso: come funziona il sito <NomeSitoPiccolo />.</h3>
      <br />
      <p style="width: 80%; margin: auto; text-align: justify">
        <strong
          >Facile Check-in è un servizio in cloud finalizzato alla gestione del
          check-in online. Il sito mette a disposizione dei clienti che abbiano
          effettuato una prenotazione presso una struttura ricettiva, una pagina
          attraverso la quale inserire i dati anagrafici dei componenti la
          prenotazione (dati di check-in). Tali dati saranno poi acquisiti
          automaticamente negli archivi della struttura ricettiva
          interessata.</strong
        >
      </p>
      <br />

      <h4>Nel seguito verranno usati i seguenti termini:</h4>
      <p class="rientro">
        <strong>Facile Check-in</strong> è il servizio in cloud (questo sito)
        che fornisce il servizio di check-in online. Nel seguito, Facile
        Check-in sarà indicato anche come “il sito”.
      </p>
      <p class="rientro">
        <strong>Partner</strong>: è un'azienda (tipicamente un sofware-house)
        che intende integrare le funzionalità di Facile Check-in all'interno del
        gestionale da lei fornito alle strutture ricettive sue clienti.
      </p>
      <p class="rientro">
        <strong>Struttura Ricettiva</strong>: la struttura ricettiva per la
        quale sia stato attivato, da parte del Partner, l'utilizzo di Facile
        Check-in all'interno del software gestionale.
      </p>
      <p class="rientro">
        <strong>Cliente Finale</strong>: la persona fisica che ha effettuato la
        prenotazione presso una Struttura Ricettiva e che viene invitata ad
        inserire nel sito i dati dei componenti la prenotazione, dati che
        saranno necessari al momento dell'accettazione in struttura.
      </p>
      <p class="rientro">
        <strong>Esempio</strong>: una casa di software (Partner) fornisce il
        proprio software gestionale alle strutture ricettive sue clienti. Il
        software gestionale non possiede già un check-in online integrato e
        pertanto la casa di software intende utilizzare le funzionalità di
        Facile Check-in per fornire un nuovo servizio alle strutture clienti.
        Dopo la necessaria integrazione telematica tra il gestionale ed il sito,
        la struttura ricettiva sarà in grado di indirizzare i propri clienti
        alla pagina tramite la quale inserire i propri dati e, successivamente,
        ricevere tali dati automaticamente all'interno dei propri archivi.
      </p>
      <br />
      <h4>Utilizzo delle funzionalità del sito</h4>
      <p class="rientro">
        Dopo essersi registrato, il Partner può utilizzare le funzionalità del
        sito e riceve la documentazione necessaria per integrarlo all'interno
        del suo software gestionale.
      </p>
      <p class="rientro">
        Il Partner accede al sito e attiva Facile Check-in per le Strutture che
        ne avessero fatto richiesta. Dal quel momento, i Clienti della Struttura
        Ricettiva verranno indirizzati alla pagina del check-in online e i loro
        dati saranno trasferiti automaticamente all'interno degli archivi della
        Struttura stessa.
      </p>

      <br />

      <hr />

      <h3>Informativa sul trattamento dei dati personali</h3>
      <br />
      <h4>1. Premessa</h4>
      <p class="rientro">
        La presente informativa viene resa ai sensi del D. Lgs. n. 196/2003 (il
        “Codice Privacy“) e del nuovo Regolamento Europeo n. 679/2016 in materia
        di protezione dei dati personali (il “Regolamento Privacy“).
      </p>
      <br />

      <h4>2. Titolare del Trattamento</h4>
      <p class="rientro">
        Il Titolare del Trattamento è il Sig. Claudio De Nardi, P.IVA
        03513050264, con sede legale in Via Ungheresca Nord, 144 – Mareno di
        Piave (TV), che può essere raggiunto tramite email all'indirizzo:
        administrator@checkin.loquos.it
      </p>
      <br />

      <h4>3. Fonte dei dati personali</h4>
      <p class="rientro">
        La raccolta dei dati personali del Partner (indirizzo email), viene
        effettuata attraverso il form di registrazione di un nuovo account.
      </p>
      <br />

      <h4>4. Finalità del trattamento</h4>
      <p class="rientro">
        I dati personali sono trattati all'unico scopo di creare un nuovo
        account tramite il quale il Partner possa utilizzare le funzionalità del
        sito.
      </p>
      <br />

      <h4>5. Modalità di trattamento dei dati</h4>
      <p class="rientro">
        In relazione alle finalità descritte, il trattamento dei dati personali
        avviene mediante strumenti automatici che consistono nell'invio di
        un'email all'indirizzo fornito, email che conterrà un link tramite il
        quale il Partner potrà completare il processo di registrazione.
      </p>
      <br />

      <h4>6. Facoltatività del conferimento dei dati</h4>
      <p class="rientro">
        Il conferimento dei dati è richiesto unicamente in caso di richiesta di
        registrare un nuovo account.
      </p>
      <br />

      <h4>7. Minori di 18 anni</h4>
      <p class="rientro">
        I servizi del sito Facile Check-in sono riservati a titolari di attività
        economiche e pertanto non vengono raccolti intenzionalmente dati
        personali di minori. Nel caso in cui informazioni su minori fossero
        involontariamente registrate, il Titolare le cancellerà in modo
        tempestivo, su richiesta degli utenti.
      </p>
      <br />

      <h4>
        8. Categorie di soggetti ai quali i dati possono essere comunicati
      </h4>
      <p class="rientro">
        I suoi dati personali non saranno trasmessi ad alcun soggetto.
      </p>
      <br />

      <h4>9. Durata della conservazione dei dati</h4>
      <p class="rientro">
        I dati forniti verranno conservati fintantoché sia attivo l'account
        creato in fase di registrazione. La definitiva eliminazione dei dati
        relativi al Partner e contestualmente di tutti i dati da esso inseriti
        nel sito, potrà avvenire solamente tramite richiesta esplicita, inviando
        un'email all'indirizzo: administrator@checkin.loquos.it.
      </p>
      <br />

      <h4>10. Base giuridica del trattamento</h4>
      <p class="rientro">
        Il trattamento dell'indirizzo email fornito in sede di registrazione
        dell'account, è obbligatorio per permettere una verifica della validità
        del processo di registrazione e conseguentemente di consentire al
        Partner di utilizzare liberamente i servizi del sito.
      </p>
      <br />

      <h4>11. Diritti dell'Interessato</h4>
      <p class="rientro">
        L'interessato ha il diritto di ottenere dal titolare del trattamento la
        conferma che sia o meno in corso un trattamento di dati personali che lo
        riguardano e in tal caso, di ottenere l'accesso ai dati personali e alle
        seguenti informazioni:
      </p>
      <ul class="doppio-rientro" style="list-style-type: lower-alpha">
        <li>le finalità del trattamento;</li>
        <li>le categorie di dati personali in questione;</li>
        <li>
          i destinatari o le categorie di destinatari a cui i dati personali
          sono stati o saranno comunicati, in particolare se destinatari di
          paesi terzi o organizzazioni internazionali;
        </li>
        <li>
          quando possibile, il periodo di conservazione dei dati personali
          previsto oppure, se non è possibile, i criteri utilizzati per
          determinare tale periodo;
        </li>
        <li>
          l'esistenza del diritto dell'interessato di chiedere al titolare del
          trattamento la rettifica o la cancellazione dei dati personali o la
          limitazione del trattamento dei dati personali che lo riguardano o di
          opporsi al loro trattamento;
        </li>
        <li>il diritto di proporre reclamo a un'autorità di controllo;</li>
        <li>
          qualora i dati non siano raccolti presso l'interessato, tutte le
          informazioni disponibili sulla loro origine;
        </li>
        <li>
          l'esistenza di un processo decisionale automatizzato, compresa la
          profilazione di cui all'articolo 22, paragrafi 1 e 4, e, almeno in
          tali casi, informazioni significative sulla logica utilizzata, nonché
          l'importanza e le conseguenze previste di tale trattamento per
          l'interessato.
        </li>
      </ul>
      <p class="rientro">
        Qualora i dati personali siano trasferiti a un paese terzo o a
        un'organizzazione internazionale, l'interessato ha il diritto di essere
        informato dell'esistenza di garanzie adeguate ai sensi dell'articolo 46
        relative al trasferimento.
      </p>
      <p class="rientro">
        Il titolare del trattamento fornisce una copia dei dati personali
        oggetto di trattamento. In caso di ulteriori copie richieste
        dall'interessato, il titolare del trattamento può addebitare un
        contributo spese ragionevole basato sui costi amministrativi. Se
        l'interessato presenta la richiesta mediante mezzi elettronici, e salvo
        indicazione diversa dell'interessato, le informazioni sono fornite in un
        formato elettronico di uso comune.
      </p>
      <br />

      <h4>12. Policy sui cookie</h4>
      <p class="rientro">
        Il sito facile Check-in utilizza esclusivamente cookie tecnici, al fine
        di garantire la normale navigazione e fruizione del sito. Per tale tipo
        di cookie non è richiesto il preventivo consenso da parte degli utenti.
      </p>

      <br />
      <br />

      <b-btn to="/Registrati" variant="success" style="width: 100%"
        >Ritorna alla pagina di registrazione</b-btn
      >
      <br />
      <br />
      <br />
    </div>
  </div>
</template>

<script>
import NomeSitoPiccolo from "@/components/NomeSitoPiccolo.vue";

export default {
  name: "PrivacyRegistrazionePartner",
  data() {
    return {};
  },
  components: {
    NomeSitoPiccolo,
  },
  watch: {
    "$store.state.Lingua"(Lingua) {
      fn_CambiaLingua(Lingua, this);
    },
  },
};

function fn_CambiaLingua(lingua, vm) {
  try {
    let labels_italiano = {};
    let labels_inglese = {};
    let labels_tedesco = {};
    let labels_francese = {};

    let labels_errori_italiano = {};
    let labels_errori_inglese = {};
    let labels_errori_tedesco = {};
    let labels_errori_francese = {};

    switch (lingua) {
      case "IT":
        vm.labels = labels_italiano;
        vm.labels_errori = labels_errori_italiano;
        break;
      case "EN":
        vm.labels = labels_inglese;
        vm.labels_errori = labels_errori_inglese;
        break;
      case "DE":
        vm.labels = labels_tedesco;
        vm.labels_errori = labels_errori_tedesco;
        break;
      case "FR":
        vm.labels = labels_francese;
        vm.labels_errori = labels_errori_francese;
        break;
      default:
        vm.labels = labels_inglese;
        vm.labels_errori = labels_errori_inglese;
        break;
    }
  } catch (error) {
    vm.registraErrore(error, "InformativaRegistrazionePartner-fn_CambiaLingua");
  }
}
</script>

<style scoped>
.rientro {
  padding-left: 20px;
  text-align: justify;
}
.doppio-rientro {
  padding-left: 40px;
  text-align: justify;
}
.triplo-rientro {
  padding-left: 60px;
  text-align: justify;
}
</style>
